'use strict';

export const media = (() => {

    const init = () => {
        $('.tab__item:not(.is-disabled)').each((index, element) => {
            $(element).on('click', (event) => {
                $(element).addClass('is-active').siblings().removeClass('is-active');
                $(`.content:eq(${index})`).addClass('is-active').siblings().removeClass('is-active');
            });
        })
    };

    return {
        init: init,
    };
})();
